import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Turnout',
    description: 'Turnout is the all-in-one ticketing platform for concerts, conferences, classes and everything in between. Sell tickets, scan guests in at the door and watch every sale in real time.',
    placeholder: 'Ticketing for every turnout.',
    url: getOrigin()
}
